import { ROUTE_PATH, OperationType } from "common/constants/sm-constants";
import { WidgetModel } from "common/models/utility-models/base-model";
import { GridMetaModel, Headers } from "common/models/utility-models/meta-model";

export class FeedbackStudentGridMetaModel extends GridMetaModel<Headers> {
    constructor() {
        super(
            'Student List',
            ROUTE_PATH.feedbackStudentList,
            ROUTE_PATH.feedbackMappinggrid,          
            false,
            false,
            8,
            false,
            false,
            ['orgname'],
            true,
            [],
            { isDownloadExcel: false, excelFileName: '', btnLabel: '', headers: [] },
            false,
            null,
            false,
            true,
            false,
            null,
            { evalKey: 'wantToDelete', evalParam: [0], decisiveParam: true }
            
        );
    }

    prepareHeaderList(): Headers[] {
        const headers: Headers[] = [];
        const orgname = new Headers('Student Name', 'orgname', false, true, 'text');
        const preview = new Headers('Preview', 'preview', false, true, 'text', '0',
            {
              isColumnNavigation: true,
              navigationUrl: ROUTE_PATH.feedbackStudentsPreview,
              navigateOperationType: OperationType.UPDATE,
              navigateTransferData: new WidgetModel()
            }
          );
        headers.push(orgname);
        headers.push(preview);
       
        return headers;
    }
}